import axios from 'axios'

const $axios = axios.create()

$axios.interceptors.response.use(
  function(response) {
    // 在发送请求之前做些什么
    return response.data
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

function postWithFormData(url, data, option) {
  if (data) {
    data = Object.keys(data).reduce((pre, cur) => {
      pre.append(cur, data[cur])
      return pre
    }, new FormData())
  }
  return $axios.post(
    url,
    data,
    option &&
      Object.assign(
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        },
        option
      )
  )
}

/**
 * 获取验证码, 绑定手机号用
 * @param {object} {openid, 手机号}
 */
export const checkKaptcha = function({ openid, phone }) {
  return postWithFormData('/cms/weixin/sendSMS/checkKaptcha', {
    openid,
    phone
  })
}

export const sendSMSAdd = function({ openid, phone, code, sourceOfVerify = 'newHwHome' }) {
  return postWithFormData('/cms/weixin/sendSMS/add', {
    openid,
    phone,
    code,
    sourceOfVerify
  })
}
